// Standard ERC20 function selectors
import {
  type AbiFunction,
  erc20Abi,
  erc721Abi,
  toFunctionSelector,
} from 'viem';

/**
 * Standard attribute name for distributed trace ID across all services.
 * Used in logging bindings for correlation between extension, connect-app, and connect-worker.
 */
export const DD_TRACE_ID_ATTR = 'extensionTraceId';

// If we want to filter for only major methods, we can use this
// const ERC20_COMMON_METHODS = ['approve', 'transfer'];
export const ERC20_CALLDATA_FUNCTIONS = erc20Abi
  .filter((fn) => fn.type === 'function')
  .map((fn) => toFunctionSelector(fn as AbiFunction));

// Standard ERC20 EIP-712 typed data types
export const ERC20_EIP712_TYPEDDATA: string[] = [
  'Permit', // ERC20 permit
];

// If we want to filter for only major methods, we can use this
// const ERC721_COMMON_METHODS = [
//   'approve',
//   'transferFrom',
//   'safeTransferFrom',
//   'setApprovalForAll',
// ];
export const ERC721_CALLDATA_FUNCTIONS: string[] = erc721Abi
  .filter((fn) => fn.type === 'function')
  .map((fn) => toFunctionSelector(fn as AbiFunction));
